import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import NumberPatternGame from '../game/NumberPatternGame';
import gameData, { GameVersions } from '../gameData';
import RoundIndicator from '../ui/RoundIndicator';
import EndScreen from './EndScreen';

export default class GameScreen extends Phaser.Scene {
  static get KEY() { return 'GameScreen'; }

  init() {
    this.cameras.main.setBackgroundColor(gameData.gameVersion === GameVersions.Number ? 0x6994CD : 0x5E2B85);
  }

  create() {
    this.roundIndicator = new RoundIndicator(this, 10,{ _thickness: 1,_lineColor: 0xA2A4A7,_fillColor: 0xA2A4A7 },{ _thickness: 1,_lineColor: 0xD9DBDC,_fillColor: 0xD9DBDC },null);
    this.add.existing(this.roundIndicator);
    this.roundIndicator.alpha = 0;

    const instStr = gameData.gameMode === 'race' ? ABCyaPhaser.Localization.instance.getLocalizedString('race_mode_instructions') : ABCyaPhaser.Localization.instance.getLocalizedString('practice_mode_instructions');
    this.instTxt = ABCyaPhaser.Text.addText(0,40, '16pt', 0xDD9E26, FontKeys.carton_sixregular, instStr, this, false).setOrigin(0);
    this.instTxt.x = (this.scale.width / 2) - (this.instTxt.width / 2);
    this.instTxt.alpha = 0;

    this.patternGame = new NumberPatternGame(this);
    this.add.existing(this.patternGame);
    this.patternGame.on('SHOW_ROUND', this.updateRound, this);
    this.patternGame.on('END_ROUND', this.hideRound,this);
    this.patternGame.once('END_GAME', this.finishGame, this);

    this.patternGame.startGame();

    this.input.on(Phaser.Input.Events.GAME_OUT, (time, event) => {
      if (event instanceof MouseEvent) {
        this.input.manager.onMouseUp(event);
      }
    });
  }

  updateRound (e) {
    this.roundIndicator.showRound(e._roundNum);
    ABCyaPhaser.Tweens.addTween(this.roundIndicator, 300, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.instTxt, 300, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
  }

  hideRound () {
    this.roundIndicator.alpha = 0;
    this.instTxt.alpha = 0;
  }

  finishGame () {
    this.patternGame.off('SHOW_ROUND');
    this.patternGame.off('END_ROUND');
    this.cleanUp();
  }

  cleanUp () {
    this.sound.stopAll();

    this.patternGame = null;

    this.scene.start(EndScreen.KEY);
  }

  update() {
    // update game
    if (this.patternGame) this.patternGame.updateGame();
  }
}